import { ApolloLink } from 'apollo-link';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import Vue from 'vue';
import gql from 'graphql-tag'
import { onError } from "apollo-link-error";

const onErrorLink = onError(({ response, operation, graphQLErrors, networkError }) => {
    console.log(123123, "!!!")
    if (operation.operationName === "IgnoreErrorsQuery") {
        response.errors = null;
    }

    if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) => {
            _i.bus.$emit("SERVER_ERROR", message);
        });

    if (networkError) console.log(`[Network error]: ${networkError}`);
});


const link = ApolloLink.from([
    onErrorLink,
    new HttpLink({ uri: '/api/v1/graphql' })
]);

const graphQlClient = new ApolloClient({
    // Provide the URL to the API server.
    link: link,
    // Using a cache for blazingly
    // fast subsequent queries.
    cache: new InMemoryCache(),
});


Vue.$gql = {
    get: async function(query, variables = {}) {
        if (!query) throw new Error("gql.get Error: No query");
        if (typeof query === 'string') {
            query = gql `${query}`;
        }
        try {
            let res = await graphQlClient.query({ query, variables });
            console.log(res)
            return res.data;
        } catch (e) {
            console.log(e.graphQLErrors)
            return { errors: e.graphQLErrors }
        }
    },
    set: async function(mutation, variables = {}) {
        if (!mutation) throw new Error("gql.set Error: No mutation");
        if (typeof mutation === 'string') {
            mutation = gql `${mutation}`;
        }
        let res = await graphQlClient.mutate({ mutation, variables });
        console.log(123, res)
        try {
            return res.data;
        } catch (e) {
            console.log(e.graphQLErrors)

            return { errors: e.graphQLErrors }
        }

    }
}




Object.defineProperties(Vue.prototype, {
    $gql: {
        get() {
            return Vue.$gql;
        }
    }

});




export default graphQlClient;